import React from 'react';
import { useNavigate } from 'react-router-dom';
import BottomNavigation from '../components/BottomNavigation';
import './Privacy.css';

const Privacy: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="privacy-page">
      <header className="privacy-header">
        <button className="back-button" onClick={() => navigate('/profile')}>
          ←
        </button>
        <h1>Privacy Policy</h1>
        <div className="header-spacer"></div>
      </header>

      <div className="privacy-content">
        <div className="privacy-section">
          <h3>Information We Collect</h3>
          <p>
            We collect information that you provide directly to us, including your name, 
            email address, phone number, and other information you choose to provide.
          </p>
        </div>

        <div className="privacy-section">
          <h3>How We Use Your Information</h3>
          <p>
            We use the information we collect to provide, maintain, and improve our services, 
            process transactions, send you technical notices and support messages, and communicate 
            with you about products and services.
          </p>
        </div>

        <div className="privacy-section">
          <h3>Data Security</h3>
          <p>
            We implement appropriate security measures to protect your personal information. 
            However, no method of transmission over the Internet is 100% secure.
          </p>
        </div>

        <div className="privacy-section">
          <h3>Your Rights</h3>
          <p>
            You have the right to access, update, or delete your personal information at any time. 
            You can do this through your account settings or by contacting us.
          </p>
        </div>

        <div className="privacy-section">
          <h3>Contact Us</h3>
          <p>
            If you have any questions about this Privacy Policy, please contact us at 
            privacy@sparkademy.com
          </p>
        </div>
      </div>

      <BottomNavigation />
    </div>
  );
};

export default Privacy;

